import {
    LISTING_PROPERTY_SUBTYPE_HOUSE_OPTIONS,
    LISTING_PROPERTY_SUBTYPE_APARTMENT_OPTIONS,
    LISTING_PROPERTY_SUBTYPE_LAND_OPTIONS,
    LISTING_PROPERTY_SUBTYPE_RECREATIONAL_OPTIONS,
    LISTING_PROPERTY_SUBTYPE_OTHER_OPTIONS,
    ListingPropertyCategory,
} from '../../listings/definitions/propertyTypes';
import { ADVERT_TXN_TYPE_OPTIONS, AdvertTxnType } from '../definitions/txnType';
import { LISTING_TXN_TYPE_OPTIONS } from '../../listings/definitions/txnType';
import { INQUIRY_TXN_TYPE_OPTIONS } from '../../inquiries/definitions/txnType';

/*
export type AdvertTxnType = {
    key: AdvertTxnType;
    text: string;
    slug: string;
};
*/

/*
export const ADVERT_TXN_TYPES = [
    ...ADVERT_TXN_TYPE_OPTIONS.map((i) => ({
        key: i.key,
        text: i.value,
        slug: i.slug,
    })),
] as const;
*/

/* Typ inzeratu ako dve zmysluplne skupiny (namiesto jedneho plocheho zoznamu). */
export const TXN_TYPE_GROUPS = [
    { label: 'Ponuka', options: LISTING_TXN_TYPE_OPTIONS },
    { label: 'Dopyt', options: INQUIRY_TXN_TYPE_OPTIONS },
] as const;

/* Krok a bezpecne hranice cenoveho / plosneho rozsahu (ked filterSettings chyba). */
export const PRICE_STEP = 5000;
export const PRICE_FALLBACK_MAX = 1000000;
export const AREA_STEP = 5;
export const AREA_FALLBACK_MAX = 1000;

export type QuickRange = { label: string; from: number | null; to: number | null };

/* Rychle cenove presety - from/to = null znamena "od minima" / "do maxima". */
export const PRICE_QUICK_RANGES: QuickRange[] = [
    { label: 'do 50 tis.', from: null, to: 50000 },
    { label: 'do 100 tis.', from: null, to: 100000 },
    { label: 'do 150 tis.', from: null, to: 150000 },
    { label: 'do 200 tis.', from: null, to: 200000 },
    { label: 'do 300 tis.', from: null, to: 300000 },
    { label: '300–500 tis.', from: 300000, to: 500000 },
    { label: '500–750 tis.', from: 500000, to: 750000 },
    { label: 'nad 750 tis.', from: 750000, to: null },
];

/* Rychle presety pre plochu (m2). */
export const AREA_QUICK_RANGES: QuickRange[] = [
    { label: 'do 50 m²', from: null, to: 50 },
    { label: 'do 80 m²', from: null, to: 80 },
    { label: 'do 120 m²', from: null, to: 120 },
    { label: '120–200 m²', from: 120, to: 200 },
    { label: 'nad 200 m²', from: 200, to: null },
];

export function formatPrice(n: number | undefined | null) {
    return (n ?? 0).toLocaleString('sk-SK') + ' €';
}

export function formatArea(n: number | undefined | null) {
    return (n ?? 0).toLocaleString('sk-SK') + ' m²';
}

export const ADVERT_PROPERTY_CATEGORIES = [
    {
        key: ListingPropertyCategory.HOUSE,
        text: 'Domy',
        icon: '/images/filter/filter_ico_domy.svg',
        iconActive: '/images/filter/filter_ico_domy_y.svg',
        types: LISTING_PROPERTY_SUBTYPE_HOUSE_OPTIONS,
    },
    {
        key: ListingPropertyCategory.APARTMENT,
        text: 'Byty',
        icon: '/images/filter/filter_ico_byty.svg',
        iconActive: '/images/filter/filter_ico_byty_y.svg',
        types: LISTING_PROPERTY_SUBTYPE_APARTMENT_OPTIONS,
    },
    {
        key: ListingPropertyCategory.LAND,
        text: 'Pozemky',
        icon: '/images/filter/filter_ico_pozemky.svg',
        iconActive: '/images/filter/filter_ico_pozemky_y.svg',
        types: LISTING_PROPERTY_SUBTYPE_LAND_OPTIONS,
    },
    {
        key: ListingPropertyCategory.RECREATIONAL,
        text: 'Rekreačné',
        icon: '/images/filter/filter_ico_rekreacne.svg',
        iconActive: '/images/filter/filter_ico_rekreacne_y.svg',
        types: LISTING_PROPERTY_SUBTYPE_RECREATIONAL_OPTIONS,
    },
    {
        key: ListingPropertyCategory.OTHER,
        text: 'Ostatné',
        icon: '/images/filter/filter_ico_ostatne.svg',
        iconActive: '/images/filter/filter_ico_ostatne_y.svg',
        types: LISTING_PROPERTY_SUBTYPE_OTHER_OPTIONS,
    },
];
